import React, {useEffect, useState} from 'react';

//import * as LogFunctions from './../Helpers/LogFunctions';
import {
    ActivityIndicator,
    Modal,
    ScrollView,
    View
} from '../../../custom-packages/react-native-components-in-react/react-native-components-in-react';


import {useSelector} from 'react-redux';

import TFoodEditorScreen from './Translations/TFoodEditorScreen';
import {DarkButton, ThemeButton} from '../../../custom-packages/react-button-package/ButtonPackage';
import AppConfig from '../../../AppConfig';
import ChocoForm from '../../../custom-packages/react-chocoforms/legacy/ChocoForm';

import FoodPricing from "./FoodPricing";

const timerMs = 500;

const FoodEditorModal = (props) => {
    const auth = useSelector(state => state.Auth);
    const id = props.id;

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
    const [food, setFood] = useState(null);
    const [prices, setPrices] = useState([]);
    const [ingredients, setIngredients] = useState([]);
    const [form, setForm] = useState({
        controls: {
            foo_name: {
                elementType: 'input',
                label: TFoodEditorScreen[AppConfig.lang].NAME,
                elementConfig: {
                    placeholder: TFoodEditorScreen[AppConfig.lang].NAME,
                    autoCapitalize: 'words'
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
            },
            foo_description: {
                elementType: 'input',
                label: TFoodEditorScreen[AppConfig.lang].DESCRIPTION,
                elementConfig: {
                    placeholder: TFoodEditorScreen[AppConfig.lang].DESCRIPTION,
                    autoCapitalize: 'words'
                },
                value: '',
                validation: {
                    required: false
                },
                valid: false,
                touched: false,
            },
        },
        saveButton: false
    });

    useEffect(async () => {
        if (!props.visible || food)
            return;

        const response = await fetch(AppConfig.URL + "/Food/EditorData/" + id, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': auth.token
            }
        });

        var json = await response.json();

        const controls = { ...form.controls };
        const saveButton = form.saveButton ? { ...form.saveButton } : false;

        controls.foo_name.value = json.food.foo_name;
        controls.foo_description.value = json.food.foo_description;

        setLoading(false);
        setFood(json.food);
        setPrices(json.prices);
        setIngredients(json.ingredients);
        setForm({
            controls: controls,
            saveButton: saveButton
        });
    }, [props.visible]);

    if (loading)
        return <Modal
            visible={props.visible}
            onRequestClose={props.onRequestClose}
        >
            <ActivityIndicator style={{ marginTop: 50, marginBottom: 50 }} />
        </Modal>

    return (
        <Modal
            visible={props.visible}
            onRequestClose={props.onRequestClose}
        >
            <ScrollView style={{ width: '100%' }}>
                <View style={{ marginTop: 10 }}>
                    <View>
                        <ChocoForm
                            containerStyle={{ padding: 0 }}
                            lang={AppConfig.lang}
                            form={form}
                            onFormChange={(updatedForm) => {
                                setForm(updatedForm);
                                setSaveButtonDisabled(!updatedForm.isValidForm)
                            }}
                        />
                        <View style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
                            {saving ?
                                <ActivityIndicator style={{ marginRight: 7 }} />
                                :
                                null
                            }
                            <ThemeButton
                                disabled={saveButtonDisabled}
                                text={TFoodEditorScreen[AppConfig.lang].SAVE}
                                onPress={async () => {
                                    const controls = { ...form.controls };

                                    if (form.isValidForm) {
                                        setSaving(true);
                                        setSaveButtonDisabled(true);

                                        let formData = {};

                                        formData['foo_id'] = id;

                                        for (let key in controls) {
                                            formData[key] = controls[key].value;
                                        }

                                        const response = await fetch(AppConfig.URL + '/Food/Create/' + id, {
                                            method: 'POST',
                                            headers: {
                                                'Accept': 'application/json',
                                                'Content-Type': 'application/json',
                                                'Authorization': auth.token
                                            },
                                            body: JSON.stringify(formData)
                                        });

                                        const data = await response.json();

                                        if (data.success) {
                                            const eventData = data.food;

                                            props.onDataChange({ eventData });
                                        }

                                        setSaving(false);
                                    } else {

                                    }
                                }}
                            />
                        </View>
                    </View>
                    <View>
                        <h4>
                            {TFoodEditorScreen[AppConfig.lang].PRICES}
                        </h4>
                        <PricingPanel
                            food={food}
                            prices={prices}
                            setPrices={setPrices}
                        />
                    </View>
                </View>
            </ScrollView>
        </Modal>
    );
}

export default FoodEditorModal;

const PricingPanel = (props) => {
    const [newPriceOpen, setNewPriceOpen] = useState(false)

    return <View>
        {
            props.prices.map(item => <FoodPricing
                key={item.fpr_id}
                style={{ marginBottom: 25 }}
                foodID={props.food.foo_id}
                item={item}
                deletable={true}
            />)
        }
        {
            newPriceOpen ?
                <FoodPricing
                    foodID={props.food.foo_id}
                    editable={true}
                    onCancel={() => {
                        setNewPriceOpen(false)
                    }}
                    onSuccess={(newItem) => {
                        const prices = [...props.prices];

                        prices.push(newItem)

                        props.setPrices(prices)
                        setNewPriceOpen(false)
                    }}
                />
                :
                <View>
                    <DarkButton
                        text={'+ ' + TFoodEditorScreen[AppConfig.lang].ADD_PRICE}
                        onPress={() => {
                            setNewPriceOpen(true)
                        }}
                        style={{ textAlign: 'center' }}
                    />
                </View>
        }
    </View>
}

/*
const IngredientsPanel = (props) => {
    const timerRef = useRef(null);
    const auth = useSelector(state => state.Auth);

    const [removing, setRemoving] = useState(false);
    const [fetchingFilteredIngredients, setFetchingFilteredIngredients] = useState(true);
    const [processingIngredient, setProcessingIngredient] = useState(false);
    const [ingredientValue, setIngredientValue] = useState('');
    const [filteredIngredients, setFilteredIngredients] = useState([]);

    const ingredientToggle = async (item) => {
        const response = await fetch(AppConfig.URL + '/Ingredient/ToggleFoodIngredient/', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': auth.token
            },
            body: JSON.stringify({
                FIN_FOOD_ID: props.food.foo_id,
                FIN_INGREDIENT_ID: item.inG_ID,
            })
        });

        var json = await response.json();

        if (json.success) {
            const eventData = json.foodIngredient;
            eventData.ingredient = item;

            const newIngredients = [...props.ingredients];
            const ingredientIndex = newIngredients.findIndex(i => i.ingredient.inG_ID == eventData.ingredient.inG_ID);

            if (ingredientIndex == -1) {
                newIngredients.push(eventData);
            } else {
                newIngredients.splice(ingredientIndex, 1);
            }

            props.setIngredients(newIngredients);
        }

        return json;
    }

    useEffect(() => {
        if (timerRef.current)
            clearTimeout(timerRef.current);

        if (!ingredientValue) {
            setFilteredIngredients([]);
            return;
        }

        timerRef.current = setTimeout(async () => {
            const response = await fetch(AppConfig.URL + '/Ingredient/Index/?Ingredient=' + ingredientValue + '&FoodID=' + props.food.foo_id + "&ExcludeSelected=true", {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': auth.token
                },
            });

            let data = await response.json();

            setFilteredIngredients(data.ingredients);
            setFetchingFilteredIngredients(false);
        }, timerMs);
    }, [ingredientValue])

    return <View>
        <View style={{ overflow: 'inherit' }}>
                <CustomSelector
                    enableNewItemButton={true}
                    onNewItemPressed={async () => {
                        if (!ingredientValue)
                            return;

                        setProcessingIngredient(true);
                        const index = filteredIngredients.findIndex(i => i.inG_NAME.toLowerCase() == ingredientValue.toLowerCase());
                        let ingredient;

                        if (index > -1) {
                            ingredient = filteredIngredients[index];
                        } else {
                            const createResponse = await fetch(AppConfig.URL + "/Ingredient/Create/", {
                                method: 'POST',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json',
                                    'Authorization': auth.token
                                },
                                body: JSON.stringify({
                                    ING_NAME: ingredientValue
                                })
                            });

                            const createJson = await createResponse.json();

                            if (createJson.success) {
                                ingredient = createJson.ingredient;
                            }
                        }

                        const json = await ingredientToggle(ingredient);

                        if (json.success) {
                            setProcessingIngredient(false);
                            setIngredientValue('');
                            setFilteredIngredients([]);
                        }
                    }}
                    loading={fetchingFilteredIngredients}
                    value={ingredientValue}
                    placeholder={TFoodEditorScreen[AppConfig.lang].TOMATO}
                    className="form-control"
                    onChange={async (event) => {
                        setFetchingFilteredIngredients(true);
                        setIngredientValue(event.target.value);
                    }}
                    data={filteredIngredients}
                    itemComponent={(item) => <View style={{ padding: 10 }}>
                        <CCText>
                            {item.inG_NAME}
                        </CCText>
                    </View>}
                    onItemSelected={async (item) => {
                        if (processingIngredient)
                            return;

                        setProcessingIngredient(true);

                        const json = await ingredientToggle(item)

                        if (json.success) {
                            setProcessingIngredient(false);
                            setIngredientValue('');
                            setFilteredIngredients([]);
                        }
                    }}
                />
                {processingIngredient ?
                    <ActivityIndicator />
                    :
                    null
                }
            {props.ingredients.map(item => <View
                key={item.fiN_ID}
                style={{ padding: 4, marginTop: 5, justifyContent: 'space-between', flexDirection: 'row', alignItems: 'center' }}>
                <CCText style={{ fontSize: 20 }}>
                    -{item.ingredient.inG_NAME}
                </CCText>
                {item.removing ?
                    <ActivityIndicator size={30} />
                    :
                    <BorderlessButton
                        disabled={removing}
                        style={{ padding: '4px 8px' }}
                        textStyle={{ ...Styles.redColor }}
                        text={TFoodEditorScreen[AppConfig.lang].REMOVE}
                        onPress={async () => {
                            setRemoving(true)

                            const newIngredients = [...props.ingredients];
                            const index = newIngredients.findIndex(i => i.fiN_ID == item.fiN_ID);

                            newIngredients[index].removing = true;

                            props.setIngredients(newIngredients);

                            await ingredientToggle(item.ingredient);

                            setRemoving(false)
                        }}
                    />
                }
            </View>)}
        </View>
    </View>
} */